import {AddFavItemsMsg, AddFavItemsQuery, FavItemDetail, RepoItem} from "../../autogenerated/ZoomBridge";

export default class AddFavItems {

  constructor() {

    this._favItems = [];
    this._actionType = "ADD";
  }


  /**
   * Converts a asset of type RepoItem to FavItemDetail
   * @param {RepoItem} asset
   */
  setAssetAsFav(asset) {
    let favItemDetail = new FavItemDetail();
    favItemDetail.setBid(asset.getBid());
    favItemDetail.setFuid(asset.getFuid());
    favItemDetail.setName(asset.getName());
    favItemDetail.setIsFile();
    favItemDetail.setMtime(asset.getMtime());
    favItemDetail.setFqPath(asset.getRemotePath());
    favItemDetail.setLatestRRN(-1); //Todo: confirm whether it should be -1 or asset.getRrn()
    favItemDetail.setAssetType();
    //console.log("Asset fileatrributes: ", asset.getBasicFileAttributes());

    this._favItems.push(favItemDetail);

    return this;
  }

  setAssetFav(asset) {
    if (asset)
      this._favItems.push(asset);
    return this;
  }

  setRemove() {
    this._actionType = "REMOVE";
    return this;
  }

  run() {
    let query = new AddFavItemsQuery();
    let msg = new AddFavItemsMsg();
    msg.setFavItemObjectArray(this._favItems);
    msg.setActionType(this._actionType);
    query.message = msg;
    return query.run();
  }

}